import React from 'react';
import { createPortal } from 'react-dom';
import { Tooltip, Paper, Box } from '@mui/material';
import { useMap, useMapEvents } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import CircularProgress, { circularProgressClasses } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useState, useEffect, useMemo, useRef } from 'react';
import LayersIcon from '@mui/icons-material/Layers';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Filter, FilterAlt } from '@mui/icons-material';
import { setModal } from '../../../store/reducers/helpersReducer';
import L from 'leaflet';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { selectConclusionsForUser } from '../../../store/selectors/supervisionSelector';





const ConclusionsTableButton = () => {
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = useState(false)
    const buttonRef = useRef(null);
    const conclusions = useSelector(selectConclusionsForUser)
    const [count, setCount] = useState(0)
    const buttonPosition = useMemo(() => {
        const buttonRect = buttonRef.current?.getBoundingClientRect();
        return buttonRect ? {
            top: buttonRect.top,
            left: buttonRect.left,
            right: buttonRect.right,
            bottom: buttonRect.bottom,
            width: buttonRect.width,
            height: buttonRect.height
        } : null;
    }, [buttonRef.current]);


    useMapEvents({
        'modal:open': (e) => {
            if (e.modalType !== 'conclusionsTable') {
                setIsOpen(false)
            }
        },
        'modal:close': () => {
            setIsOpen(false)
        }
    })

    const handleOpenToggle = (newState) => {
        setIsOpen(newState)
        if (newState) {
            dispatch(setModal({ modalType: 'conclusionsTable', modalProps: { buttonPosition } }))
        } else {
            dispatch(setModal(null))
        }
    }


    useEffect(() => {
        if (conclusions) {
            setCount(conclusions.reduce((t, r) => t + (r.tbl?.filter(tb => tb.stage === '1').length || 0), 0))
        }
    }, [conclusions])

    useEffect(() => {
        if (buttonRef.current) {
            L.DomEvent.disableClickPropagation(buttonRef.current)
            L.DomEvent.disableScrollPropagation(buttonRef.current)
        }
    }, [buttonRef.current])

    if (!count || count === 0) return null

    return createPortal(
        <Box sx={{ zIndex: 1202, display: 'flex', order: 4, pointerEvents: 'auto', width: 'fit-content' }}>
            <Tooltip title='Замечания Заказчика' placement='right' arrow>
                <Paper
                    elevation={3}
                    ref={buttonRef}
                    sx={{
                        display: 'flex',
                        order: 3,
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: window.innerWidth < 768 ? 26 : 34,
                        height: window.innerWidth < 768 ? 26 : 34,
                        // m: '10px 10px 5px 5px',
                        opacity: 0.9,
                        bgcolor: 'rgb(40, 40, 40)',
                        boxShadow: '0px 2px 6px grey',
                        color: 'rgb(0, 174, 255)',
                        cursor: 'pointer',
                        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                        '&:hover': {
                            bgcolor: 'rgb(50, 50, 50)',
                            transform: 'scale(1.1)',

                        },
                        // zoom: window.innerWidth < 768 ? 0.8 : 1
                    }}
                    onClick={() => handleOpenToggle(!isOpen)}
                >
                    <ListAltIcon sx={{ fontSize: window.innerWidth < 768 ? 19 : 24, color: '#f19e39' }} />
                    <Box sx={{ position: 'relative', display: 'inline-block' }}>
                        {/* <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="24px" fill="#f19e39" style={{ alignSelf: 'center' }} >
                            <path d="M240-280h200v-80H240v80Zm400 0h80v-80h-80v80ZM240-440h200v-80H240v80Zm400 0h80v-240h-80v240ZM240-600h200v-80H240v80Zm-80 480q-33 0-56.5-23.5T80-200v-560q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v560q0 33-23.5 56.5T800-120H160Zm0-80h640v-560H160v560Zm0 0v-560 560Z"
                            />
                        </svg> */}


                        {/* Badge для ready - нижний правый угол */}
                        {count > 0 && (
                            <Badge
                                badgeContent={count}
                                color="secondary"
                                max={999}
                                variant="standard"
                                sx={{
                                    position: 'absolute',
                                    bottom: window.innerWidth < 768 ? -14 : -16,
                                    right: window.innerWidth < 768 ? -2 : -4,
                                    '& .MuiBadge-badge': {
                                        color: 'black',
                                        backgroundColor: '#f19e39',
                                        fontSize: window.innerWidth < 768 ? 9 : 12,
                                        padding: '2px',
                                        width: 'auto',
                                        height: 'auto',
                                    }
                                }}
                            />
                        )}
                    </Box>


                </Paper>
            </Tooltip>
        </Box>

        , document.getElementById("map-controls-left-top")
    )




};

export default ConclusionsTableButton; 